import type { StepType } from "@reactour/tour";
import welcome from "./welcome";
import firstSlide from "./firstSlide";
import addImage from "./addImage";
import saveShare from "./saveShare";
import whatsNext from "./whatsNext";

export const teacherTourSteps = (_hostId: string) => {
	const steps: StepType[] = [
		...welcome,
		...firstSlide,
		...addImage,
		...saveShare,
		...whatsNext,
	];
	return steps;
};
